import { useId, useRef } from "react";
import { useFocusTrap } from "../../hooks/useFocusTrap";

type Props = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({ open, title, message, confirmLabel = "Confirm", danger, onConfirm, onCancel }: Props) {
  const cardRef = useRef<HTMLDivElement>(null);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const titleId = useId();
  const messageId = useId();

  // Initial focus lands on Cancel: this is the shared destructive-action
  // primitive, so the safe action must be the one a stray Enter hits.
  useFocusTrap(cardRef, open, {
    onEscape: onCancel,
    initialFocus: () => cancelRef.current,
  });

  if (!open) return null;

  return (
    <div className="overlay-scrim" onClick={onCancel}>
      <div
        ref={cardRef}
        className="overlay-card confirm-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-body">
          <div id={titleId} className="confirm-title">{title}</div>
          <div id={messageId} className="confirm-message">{message}</div>
        </div>
        <div className="confirm-actions">
          <button ref={cancelRef} className="btn btn-ghost" onClick={onCancel}>Cancel</button>
          <button className={`btn ${danger ? "btn-danger" : "btn-primary"}`} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
